// extracted by mini-css-extract-plugin
module.exports = {"selectedCompany":"styles_selectedCompany__10lxE","companyItem":"styles_companyItem__2G4H9"};